import firebase from "firebase/app";

const state = {
  gamesInfo: {},
  error: null
};

const getters = {
  getGamesInfo(state) {
    return state.gamesInfo;
  },
  getGameInfoError(state) {
    return state.error;
  }
};

const mutations = {
  setGamesInfo(state, payload) {
    state.games = payload;
  },
  setGameInfoError(state, payload) {
    state.error = payload;
  }
};

const actions = {
  async updateGameInfoById(
    { commit },
    { gamer_id, game_id, date_off, active }
  ) {
    try {
      await firebase
        .database()
        .ref(`/gamers/${gamer_id}/game_info/${game_id}`)
        .update({ date_off, active });
    } catch (e) {
      commit("setGameInfoError", e);
      throw e;
    }
  }
};
export default {
  state,
  mutations,
  actions,
  getters
};
